import * as Common from '@/agiles/common';

export class SignupResult extends Common.ObjectBase {
  constructor() {
    super('SignupResult');
  }    
    public success:boolean = false;
    public message:string ='';
}
export enum signupPurposeFlags{
    default = 0,
    introduction = 1,
    replace = 2,
    partner = 3,
}
export enum signupUserCountFlags{
    //1～2名・3～9名・10～19名・20～29名・30名以上
    default = 0,
    under2 = 1,
    over3 = 2,
    over10 = 3,
    over20 = 4,
    over30 = 5,
}
export enum signupScheduleFlags{
    //なるべく早く・3カ月以内・6カ月以内・1年以内・未定(良いものがあったら)
    default = 0,
    soon = 1,
    within3month = 2,
    within6month = 3,
    within12month = 4,
    notscheduled = 5,
}
export class MarketingInfo  {
    public purpose : signupPurposeFlags = signupPurposeFlags.default;
    public userCount : signupUserCountFlags = signupUserCountFlags.default;
    public schedule : signupScheduleFlags = signupScheduleFlags.default;
    public productLines : string = null;
}
export class SignupQuery extends Common.Query {
    constructor(){
        super('SignupQuery',new Common.ModelBinder(SignupResult,false));
    }
    public tenantId: string = '';
    public tenantName: string = '';
    public tenantTelNo : string = '';
    public tenantAdminId : string = '';
    public tenantAdminName : string = '';    
    public licenseFlag : number;
    public functionFlag : number = 1;
    // 常に案件がONの利用機能
    public get functionFlagOnProjectItem():number {return this.functionFlag | Common.functionFlags.ProjectItem;}
    public set functionFlagOnProjectItem(value:number) {this.functionFlag = value | Common.functionFlags.ProjectItem;}
    public generateSampleData : boolean = true;
    public provisioningTemplate : string = null;
    public info : Common.PaymentInfoPayJP = null;
    public isContract :boolean = false;
    public hasFreePeriod :boolean = false; // 有償登録だが無料期間あり
    public description:string = '';
    public partnerKey:string = null;
    public introductionCode:string = null;   // パートナー制度改定後のパートナーコード
    public shipmentFlag: number = 0;
    public marketingInfo : MarketingInfo = new MarketingInfo();
    public couponCode:string='';
}

export class SignupPartnerQuery extends Common.Query {
    constructor(partnerKey:string){
        super('SignupPartnerQuery',null);
        this.partnerKey = partnerKey;
    }
    public partnerKey:string = null;
}